import {
  defaultIcon,
  hardcodedIconMap,
  hardcodedIconNameMap,
} from 'components/HourStateLabel.constants';
import React from 'react';
import type { HourState } from 'redux/modules/hourStates.schema';
import { defaultIcons } from './HourStateIconColorPicker.constants';

export type IconProps<T extends string> = { name: T } & Omit<
  Parameters<(typeof defaultIcons)[T]>[0],
  'name'
>;

function HourStateIcon<T extends string>({ name, ...props }: IconProps<T>) {
  if (!defaultIcons[name]) {
    console.error('cant find icon "%s"', name);
    return null;
  }

  return React.createElement(defaultIcons[name], {
    ...props,
  } as any);
}

export default HourStateIcon;

export const getHourStateIcon = (state: HourState) =>
  state.icon ? (
    <HourStateIcon name={state.icon} />
  ) : (
    // TODO: Get rid of this when we have all icons in place
    (hardcodedIconMap.get(state.name) ?? (
      <HourStateIcon name={hardcodedIconNameMap.get(state.name) || defaultIcon} />
    ))
  );
